import { render, staticRenderFns } from "./OptionsSelect.vue?vue&type=template&id=db0ce50e&scoped=true"
import script from "./OptionsSelect.vue?vue&type=script&lang=js"
export * from "./OptionsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0ce50e",
  null
  
)

export default component.exports